var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolicy2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9277 2.5C13.3673 2.5 14.7477 3.07195 15.7656 4.08984C16.7835 5.10774 17.3555 6.48821 17.3555 7.92773C17.3543 8.99692 17.0373 10.0419 16.4443 10.9316C15.8512 11.8216 15.0082 12.5171 14.0215 12.9297L13.6318 13.0918L13.7275 13.5029L15.4941 21.1602L11.9277 17.5938L11.5742 17.9473L8.36035 21.1602L10.127 13.5078L10.2217 13.0967L9.83301 12.9336C8.84593 12.5206 8.00315 11.8252 7.41016 10.9346L7.40332 10.9248L7.39648 10.916C7.11443 10.5308 6.5 9.34239 6.5 7.92773C6.5 6.48821 7.07195 5.10774 8.08984 4.08984C9.10774 3.07195 10.4882 2.5 11.9277 2.5Z",
    stroke: "#636980"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 2.5,
    stroke: "#636980"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 5.5,
    stroke: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy2);
export default __webpack_public_path__ + "static/media/Policy 2.c0f7f6307a59f5bce264136f7e95ad57.svg";
export { ForwardRef as ReactComponent };